<template>
<div class="home">
  <div class="position-relative">
    <section class="section section-hero section-shaped">
      <div class="shape shape-style-1 shape-default">
        <span class="span-150"></span>
        <span class="span-50"></span>
        <span class="span-50"></span>
        <span class="span-75"></span>
        <span class="span-100"></span>
        <span class="span-75"></span>
        <span class="span-50"></span>
        <span class="span-100"></span>
        <span class="span-50"></span>
        <span class="span-100"></span>
      </div>
      <div class="container shape-container d-flex align-items-lg-center align-items-center">
        <div class="col">
          <div class="row d-flex align-items-center justify-content-center">
            <div class="col-lg-6 text-center">
              <img src="../assets/img/auspidev-logo-v2/logo_transparent.png" style="width: 60%;" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>

export default {
  name: "home"
};
</script>

<style scoped>
.section-hero {
  height: 100vh;
}
</style>
